<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} guía
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <ng-container *ngIf="service_alert.show">
          <div class="alert alert-{{service_alert.class}} alert-dismissible fade show" role="alert">
            <button type="button" class="close" aria-label="Close" (click)="service_alert.show = false">
              <span aria-hidden="true">×</span>
            </button>
            <strong>¡Datos extraídos!, </strong> {{service_alert.message}}
          </div>
        </ng-container>
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-9">
              <div class="row">
                <div class="form-group col-lg-3">
                  <label>N° Documento<span class="required"></span></label>
                  <div class="input-group">
                    <input type="text" id="client_document" class="form-control" formControlName="document" numeric
                      required autofocus maxlength="8">
                    <div class="input-group-append bg-custom">
                      <div class="input-group-append bg-custom">
                        <div class="input-group-text pointer btn-reniec" (click)="extractDni()" data-toggle="tooltip"
                          data-placement="right" data-original-title="Extraer de Reniec"></div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="submitted && f['document'].errors">
                    <small class="text-danger" *ngIf="f['document'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-9">
                  <label>Nombres completos <span class="required"></span></label>
                  <input type="text" id="fullname" class="form-control" formControlName="fullname">
                </div>
                <div class="form-group col-lg-3">
                  <label>N. referencial <span class="f-s-11">(apelativo)</span></label>
                  <div class="input-group">
                    <input type="text" id="client_reference_name" formControlName="reference_name" class="form-control">
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Celular <span class="required"></span></label>
                  <input type="text" class="form-control" numeric formControlName="cellphone" required>
                </div>
                <div class="form-group col-lg-3">
                  <label>Correo electrónico</label>
                  <input type="email" class="form-control" formControlName="email">
                </div>
                <div class="form-group col-lg-3">
                  <label>Fecha nacimiento</label>
                  <input type="date" id="date_birthday" class="form-control" placeholder="yy-mm-dd"
                    formControlName="date_birthday">
                </div>
                <div class="form-group col-lg-3">
                  <label>Estado</label>
                  <select class="form-control" id="statusSelected" formControlName="status">
                    <option *ngFor="let item of statusmarital" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-3">
                  <label>Sexo</label>
                  <select class="form-control" id="sexSelected" formControlName="sex">
                    <option *ngFor="let item of sexs" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-6">
                  <label>Dirección</label>
                  <textarea rows="1" class="form-control no-resize" formControlName="address"></textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <p class="text-center p-t-15">
                <ng-container *ngIf="item.value.url_image != null">
                  <img width="200" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
                </ng-container>
                <ng-container *ngIf="item.value.url_image == null">
                  <ng-container *ngIf="imageUrl == null">
                    <img id="output" width="200" src="/images/default.png" />
                  </ng-container>
                  <ng-container *ngIf="imageUrl != null">
                    <img width="200" height="165" [src]="imageUrl" alt="Preview">
                  </ng-container>
                </ng-container>
              </p>
              <p class="text-center">
                <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                  Seleccionar Imagen
                  <input id="file" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg"
                    style="visibility: hidden;">
                </label>
              </p>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
